namespace GeniuzPOS.PosShift {
    export interface PsTaxInvoiceDtForm {
        LineItemNo: Serenity.IntegerEditor;
        SalesVatType: Serenity.StringEditor;
        DocType: Serenity.IntegerEditor;
        PluCode: Serenity.StringEditor;
        SerialNo: Serenity.StringEditor;
        ItemDescription: Serenity.StringEditor;
        Qty: Serenity.DecimalEditor;
        SellUnit: Serenity.StringEditor;
        UnitPrice: Serenity.DecimalEditor;
        ExPrice: Serenity.DecimalEditor;
        ItemDiscount: Serenity.DecimalEditor;
        ItemCharge: Serenity.DecimalEditor;
        ItemNetExprice: Serenity.DecimalEditor;
        AllocatedBillDiscountVat: Serenity.DecimalEditor;
        AllocatedBillDiscount: Serenity.DecimalEditor;
        ItemNetSales: Serenity.DecimalEditor;
        ItemNetSales2: Serenity.DecimalEditor;
        VatType: Serenity.StringEditor;
        VatRate: Serenity.DecimalEditor;
        ItemVatAmt: Serenity.DecimalEditor;
        ItemVatAmt2: Serenity.DecimalEditor;
        ItemExVat: Serenity.DecimalEditor;
        ItemPromoFg: Serenity.IntegerEditor;
    }

    export class PsTaxInvoiceDtForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsTaxInvoiceDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsTaxInvoiceDtForm.init)  {
                PsTaxInvoiceDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(PsTaxInvoiceDtForm, [
                    'LineItemNo', w0,
                    'SalesVatType', w1,
                    'DocType', w0,
                    'PluCode', w1,
                    'SerialNo', w1,
                    'ItemDescription', w1,
                    'Qty', w2,
                    'SellUnit', w1,
                    'UnitPrice', w2,
                    'ExPrice', w2,
                    'ItemDiscount', w2,
                    'ItemCharge', w2,
                    'ItemNetExprice', w2,
                    'AllocatedBillDiscountVat', w2,
                    'AllocatedBillDiscount', w2,
                    'ItemNetSales', w2,
                    'ItemNetSales2', w2,
                    'VatType', w1,
                    'VatRate', w2,
                    'ItemVatAmt', w2,
                    'ItemVatAmt2', w2,
                    'ItemExVat', w2,
                    'ItemPromoFg', w0
                ]);
            }
        }
    }
}
